import React from "react";
import Grid from "@mui/material/Grid";
import StyledTextarea from "../../CommonComponents/StyledTextarea/StyledTextarea";
import {useTheme} from "../../../contexts/theme";
import {SocialPostNames} from "../../../types/socialTypes";

export interface InstagramFormState{
    caption: string
}

interface InstagramFormStateProps {
    onFieldChange: (field: string, value: string | boolean) => void;
    defaultFormState: InstagramFormState
    selectedPostType: string
}

const InstagramForm: React.FC<InstagramFormStateProps> = ({onFieldChange, defaultFormState, selectedPostType}) => {
    const theme = useTheme()

    return (
        selectedPostType !== SocialPostNames.story ? <Grid container marginTop={theme.spacing.md}>
            <Grid item lg={12} md={12}>
                <StyledTextarea
                    placeholder={'Type post caption'}
                    label={'Caption'}
                    value={defaultFormState.caption}
                    onChange={(e) => onFieldChange('caption', e.target.value)}
                    width={'100%'}
                    height={'100%'}
                />
            </Grid>
        </Grid>: <></>
    )
}

export default InstagramForm